"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    MEETING_RECORDING_CONSENT: 'meetingRecordingConsent',
};
//# sourceMappingURL=consentType.js.map